module.exports = __webpack_public_path__ + "img/Pista_02.ddca629f.png";